import { escapeRegExp } from 'utils/StringUtils';

export interface HighlightDto {
  value: string;
  index: number;
  isMatch?: boolean;
}

/**
 * Splits a string into ordered objects based on case insensitive matches
 * of a provided search string.
 * @param text to search
 * @param searchString to search with
 */
export function stringHighlightUtil(text: string, searchString = '') {
  let matches: HighlightDto[] = [];

  if (!searchString) {
    return matches;
  }

  const regex = new RegExp(escapeRegExp(searchString), 'gi');
  let found: RegExpExecArray | null;
  // tracking position in text:
  let index = 0;

  // search for matches
  while ((found = regex.exec(text)) !== null) {
    const match = {
      value: found[0],
      index: found.index,
      isMatch: true,
    };
    let value = text.substr(index, match.index - index);
    if (value) {
      // grab anything before current match
      matches.push({ value, index });
    }
    matches.push(match);
    // update tracking index:
    index = match.index + match.value.length;
  }

  // catch any trailing value:
  if (matches.length) {
    const match = matches[matches.length - 1];
    index = match.index + match.value.length;
    const tail = text.substr(index);
    if (tail) {
      matches.push({
        index: match.index + match.value.length,
        value: text.substr(match.index + match.value.length),
      });
    }
  }

  return matches;
}
